import {useNavigate, useParams} from "react-router-dom";
 import {useEffect, useState} from "react";
import axiosInstance from "../../../API/Axios/AxiosConfig";
import URLS from "../../../API/Axios/URLS";
import StarRatings from "react-star-ratings";
import "./index.css"
import ReactQuill from "react-quill";

export default function Guide({className, ...props}) {
    let {title} = useParams();
    const [guide, setGuide] = useState(null)
    const [loading, setLoading] = useState(true)
    const navigation = useNavigate()

    function fetchGuide() {
        setLoading(true)
        axiosInstance.get(URLS.getGuideList + "/" + title).then((res) => {
            setGuide(res.data?.data)
        }).catch((error) => {
            navigation("/404")
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        fetchGuide()
    }, [title])


    if (loading)
        return (
            <div className={` flex animation-window   justify-center w-full h-full ${className}`}>
                <div
                    className={" p-4 animate-pulse w-full m-4 lg:m-0 flex flex-col gap-3  shadow-2xl lg:my-10 rounded-xl  lg:w-1/2"}>
                    <p className={"text-center heading my-5 text-xl mx-auto rounded-full bg-gray-200 font-bold w-1/2"}/>
                    <p className={"text-center  text-xl   rounded-full bg-gray-200 font-bold w-1/2"}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center  text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <div>
                        <StarRatings
                            rating={0}
                            starRatedColor="blue"
                            numberOfStars={5}
                            name='rating'
                            starDimension={"20px"}
                            starSpacing={"1px"}
                        />
                    </div>
                    <p className={"text-center mt-4 text-xl   rounded-full bg-gray-200 font-bold w-1/2"}/>
                    <p className={"text-center text-xl  rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center  text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center  text-xl   rounded-full bg-gray-200 font-bold "}/>
                    <p className={"text-center text-xl   rounded-full bg-gray-200 font-bold "}/>
                </div>
            </div>

        )


    return (
        <div className={` flex justify-center overflow-auto  w-full  ${className}`}>
            <div className={" p-4 lg:px-7    shadow-2xl my-10 rounded-xl  lg:w-1/2"}>
                <p className={"text-center mt-5 text-2xl font-bold"}>
                    {guide?.title}
                </p>
                <p className={"text-start mt-5 text-base font-bold"}>
                    DIRECTIONS
                </p>
                <p className={"text-start mt-2 text-sm text-gray-600"}>
                    {guide?.directions}
                </p>
                <p className={"text-start mt-5 mb-2 text-base font-bold"}>
                    IMPORTANCE LEVEL
                </p>
                <StarRatings
                    rating={guide?.importance}
                    starRatedColor="#FE9803"
                    numberOfStars={5}
                    name='rating'

                    starDimension={"20px"}
                    starSpacing={"1px"}
                />
                <p className={"text-start mt-5 mb-2 text-base font-bold"}>
                    SUBSCORES
                </p>
                <div className={"flex flex-row gap-2 flex-wrap"}>
                    {
                        guide?.subScores?.map((subScore, index) => {
                            return (
                                <div key={index}
                                     className={"bg-white px-4 py-[1px] rounded-full border-[1px] uppercase text-[0.7rem] border-secondary-900 text-secondary-900"}>
                                    {subScore}
                                </div>
                            )
                        })
                    }

                </div>
                <p className={"text-start mt-5  text-base font-bold"}>
                    TIPS
                </p>
                <ReactQuill
                    value={guide?.description}

                    readOnly={true}
                    theme={"bubble"}
                />
            </div>
        </div>

    )
}